<div class="filter-container">
  <div class="row">
    <div class="filter-window col-12">
      <div class="row">
        <div class="title-header col-12">
          <i class="fa fa-filter" aria-hidden="true"></i> <span class="title">{{ 'RELOCATIONS.FILTER.TITLE' | translate }}</span>
          <span class="subtitle">{{ 'RELOCATIONS.FILTER.SUBTITLE' | translate }}</span>
        </div>
      </div>

      <div class="row">
        <div class="form-container col-12 row">
          <form [formGroup]="filterForm" class="row col-12">
            <div class="col-12 col-md-6">
              <div class="cell row col-12 form-group">
                <eps-select
                  [options]="definitions.places"
                  label="ORDERS.FILTER.LABELS.FROM"
                  formControlName="froms"
                  multiple
                  autoSelect
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell row col-12 form-group">
                <eps-select
                  [options]="definitions.places"
                  label="ORDERS.FILTER.LABELS.TO"
                  formControlName="tos"
                  multiple
                  autoSelect
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell row col-12 form-group">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.ETM_SHIPPING_NUMBER"
                  formControlName="etmShippingNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell row col-12 form-group">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER"
                  formControlName="etmDocumentNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell row col-12 form-group">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.SALES_ORDER_NUMBER"
                  formControlName="salesOrderNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell row col-12 form-group" *ngIf="showAdvanced">
                <eps-select
                  label="ORDERS.FILTER.LABELS.ORDER_STATUS"
                  formControlName="orderStatuses"
                  [options]="definitions.order.status"
                  [showErrors]="false"
                  autoSelect
                  multiple
                  hideOptionalMarker
                ></eps-select>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <ng-container *ngIf="(showDatesIn2rows$ | async); else showOrderDatesIn1row">
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="florderDateFrom"
                    label="ORDERS.FILTER.LABELS.ORDER_DATE_FROM"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="florderDateTo"
                    label="ORDERS.FILTER.LABELS.ORDER_DATE_TO"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
              </ng-container>
              <ng-template #showOrderDatesIn1row>
                <div class="cell col-12 form-group row">
                  <eps-label-body label="ORDERS.FILTER.LABELS.ORDER_DATE">
                    <div class="eps-body">
                      <eps-date-input
                        formControlName="florderDateFrom"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                      <eps-date-input
                        formControlName="florderDateTo"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                    </div>
                  </eps-label-body>
                </div>
              </ng-template>
              <ng-container *ngIf="(showDatesIn2rows$ | async); else showUnloadingDatesIn1row">
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="unloadingDateFrom"
                    label="ORDERS.FILTER.LABELS.UNLOADING_DATE_FROM"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="unloadingDateTo"
                    label="ORDERS.FILTER.LABELS.UNLOADING_DATE_TO"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
              </ng-container>
              <ng-template #showUnloadingDatesIn1row>
                <div class="cell col-12 form-group row">
                  <eps-label-body label="ORDERS.FILTER.LABELS.UNLOADING_DATE">
                    <div class="eps-body">
                      <eps-date-input
                        formControlName="unloadingDateFrom"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                      <eps-date-input
                        formControlName="unloadingDateTo"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                    </div>
                  </eps-label-body>
                </div>
              </ng-template>
              <div class="cell row col-12 form-group">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.RECEIVER_REFERENCE_NUMBER"
                  formControlName="customerReferenceNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell row col-12 form-group">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.RECEIVER_REFERENCE_NUMBER"
                  formControlName="customerReferenceNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell row col-12 form-group">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.SENDER_REFERENCE"
                  formControlName="senderReferenceNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell row col-12 form-group" *ngIf="showAdvanced">
                <eps-select
                  label="ORDERS.FILTER.LABELS.PALLET_ID"
                  formControlName="palletIds"
                  [options]="definitions.pallet.type"
                  [showErrors]="false"
                  multiple
                  autoSelect
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell row col-12 form-group" *ngIf="showAdvanced">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.TRANSPORTER"
                  formControlName="transporter"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
            </div>

            <div class="row col-12 filter-buttons">

              <eps-button
                [disabled]="filterForm.disabled"
                (buttonClick)="showAdvanced = true"
                type="link"
                *ngIf="!showAdvanced"
                label="ORDERS.FILTER.BUTTONS.MORE_SEARCH_OPTIONS"
              ></eps-button>
              <eps-button
                [disabled]="filterForm.disabled"
                (buttonClick)="showAdvanced = false"
                type="link"
                *ngIf="showAdvanced"
                label="ORDERS.FILTER.BUTTONS.LESS_SEARCH_OPTIONS"
              ></eps-button>
              <eps-button
                [disabled]="filterForm.disabled"
                (buttonClick)="resetFilter()"
                buttonIcon="eraser"
                minWidth="160px"
                label="SHARED.BUTTONS.CLEAR_FILTERS"
              ></eps-button>
              <eps-button
                [disabled]="filterForm.invalid || filterForm.disabled"
                [busy]="isLoading"
                (buttonClick)="filterClicked()"
                minWidth="160px"
                buttonIcon="filter"
                submit
                label="RELOCATIONS.FILTER.BUTTONS.FILTER_TEXT"
              ></eps-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
